import { Eye, Wallet, Users, ShoppingBag, BadgeCheck } from "lucide-react";
import { Reveal } from "../landing/Reveal";

const CREATORS = [
  { name: "Riya Kapoor", role: "Food Creator", grad: "from-[#FF7A00] to-[#FFB25E]", views: "2.4M", revenue: "₹86K", followers: "148K", sales: "₹2.1L" },
  { name: "Dev Malhotra", role: "Travel Creator", grad: "from-[#06B6D4] to-[#67E8F9]", views: "1.8M", revenue: "₹64K", followers: "96K", sales: "₹1.4L" },
  { name: "Ananya Iyer", role: "Learning Creator", grad: "from-[#635BFF] to-[#8B85FF]", views: "3.1M", revenue: "₹1.1L", followers: "212K", sales: "₹3.4L" },
  { name: "Arjun Nair", role: "Business Creator", grad: "from-[#00D26A] to-[#4ADE80]", views: "1.2M", revenue: "₹92K", followers: "88K", sales: "₹2.8L" },
  { name: "Sara Ali", role: "Fashion Creator", grad: "from-[#EC4899] to-[#F472B6]", views: "2.9M", revenue: "₹1.3L", followers: "176K", sales: "₹4.2L" },
];

const Stat = ({ icon: Icon, label, value }) => (
  <div className="rounded-xl border border-white/5 bg-white/[0.03] px-3 py-2.5">
    <div className="flex items-center gap-1.5">
      <Icon className="h-3 w-3 text-slate-500" />
      <span className="font-jbmono text-[9px] uppercase tracking-widest text-slate-500">{label}</span>
    </div>
    <p className="mt-1 font-display text-sm font-extrabold text-white">{value}</p>
  </div>
);

export const Creators = () => (
  <section id="creators" data-testid="creators-section" className="relative py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
          Creator Economy
        </p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          Creators don't just post here. They get paid here.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {CREATORS.map((c, i) => (
          <Reveal key={c.name} delay={0.06 * i} className="h-full">
            <div
              data-testid={`creator-card-${c.role.toLowerCase().replace(" ", "-")}`}
              className="flex h-full flex-col overflow-hidden rounded-3xl border border-white/10 bg-[#111827] transition-all duration-300 hover:-translate-y-1.5 hover:border-[#635BFF]/50"
            >
              <div className={`relative h-20 bg-gradient-to-br ${c.grad}`}>
                <div className="absolute -bottom-6 left-1/2 flex h-12 w-12 -translate-x-1/2 items-center justify-center rounded-full border-2 border-[#111827] bg-[#1F2937] font-display text-sm font-black text-white">
                  {c.name.split(" ").map((w) => w[0]).join("")}
                </div>
              </div>
              <div className="flex flex-1 flex-col px-4 pb-5 pt-8 text-center">
                <p className="flex items-center justify-center gap-1 text-sm font-bold text-white">
                  {c.name}
                  <BadgeCheck className="h-3.5 w-3.5 text-[#635BFF]" />
                </p>
                <p className="mt-0.5 font-jbmono text-[10px] uppercase tracking-widest text-slate-500">
                  {c.role}
                </p>
                <div className="mt-4 grid grid-cols-2 gap-2">
                  <Stat icon={Eye} label="Views" value={c.views} />
                  <Stat icon={Wallet} label="Revenue" value={c.revenue} />
                  <Stat icon={Users} label="Followers" value={c.followers} />
                  <Stat icon={ShoppingBag} label="Sales" value={c.sales} />
                </div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
      <p className="mt-8 text-center font-jbmono text-[10px] uppercase tracking-widest text-slate-600">
        Demo profiles — figures are illustrative
      </p>
    </div>
  </section>
);
